export default "__VITE_ASSET__DlBmwlmS__"